import React, { useContext } from 'react';
import { Grid } from 'react-bootstrap';

import { SubscriptionsMainContext } from '../../index';
import Tabs from '../../../../../components/Tabs';
import SearchGroup from '../../../../../components/Search/SearchGroup';

const SubscriptionsMainHeader = () => {
  const [store] = useContext(SubscriptionsMainContext);
  const { statuses, search_types, isLoadingTable } = store;

  return (
    <Grid fluid>
      <ul className="nav nav-tabs services-header">
        {statuses && <Tabs tab="status" tabsData={statuses} disabled={isLoadingTable} />}
        <SearchGroup
          autocomplete="on"
          sectionName="ticket"
          withSelect
          options={search_types}
          placeholder="Search"
          disabled={isLoadingTable}
        />
      </ul>
    </Grid>
  );
};

SubscriptionsMainHeader.propTypes = {

};

export default SubscriptionsMainHeader;
